import React from 'react';
import { ProgramsPage as Page } from '@sandtech-hub-monorepo/ui-kit-site';
import { AppRoutesPaths } from '../../routes/types';
import {
  supportUrlFor,
  useIsActiveUniversityStudent,
} from '../../data/useLearnerPath';

/**
 * The degree catalogue, rendered at /programs for a degree learner.
 *
 * `universityOnly` is not optional in practice here: the shared component
 * lists everything `availablePrograms` returns, which is both product types,
 * so without it a degree learner browses the GSA catalogue as well.
 */
export const DegreePrograms = () => {
  const isActiveUniversityStudent = useIsActiveUniversityStudent();
  return (
    <Page
      learningPageLink={AppRoutesPaths.Learning}
      programPageLink={AppRoutesPaths.Program}
      paymentBanner={false}
      universityOnly
      supportUrl={supportUrlFor(isActiveUniversityStudent)}
    />
  );
};
